module.exports = __webpack_public_path__ + "static/media/MacOX-icon.b68e189c.png";